import {
    AppContext
} from '@lightspeed-invoicing/core-client/frontend/index'
import * as IntegrationConstants from "../integration/IntegrationConstants.jsx"

export default {
    TopicCustomerBalanceUpdate: 'customer-balance-update',
    TopicHistoryPush: 'history-push',
    TopicUrlPathChange: 'url-path-change',
    TopicHistoryChanged: 'history-changed',
    TopicRefreshCurrentBreadcrumb: 'refresh-current-breadcrumb',
    TopicDashboardDisplay: 'dashboard-display',
    TopicInlineDescriptionEdit: 'inline-description-edit',
    TopicUserCreated: 'user-created',
    TopicIntegrationRequested: {
        [IntegrationConstants.integrationKeyAcomba]: "integration-requested-acomba",
        [IntegrationConstants.integrationKeyAdi]: "integration-requested-adi",
        [IntegrationConstants.integrationKeyApa]: "integration-requested-apa",
        [IntegrationConstants.integrationKeyDandh]: "integration-requested-dandh",
        [IntegrationConstants.integrationKeyDtools]: "integration-requested-dtools",
        [IntegrationConstants.integrationKeyHubspot]: "integration-requested-hubspot",
        [IntegrationConstants.integrationKeyQuickbooks]: "integration-requested-quickbooks",
        [IntegrationConstants.integrationKeySalesforce]: "integration-requested-salesforce",
        [IntegrationConstants.integrationKeySynnex]: "integration-requested-synnex",
    },
    TopicQuoteCreated: 'quote-created',
    TopicQuoteSent: 'quote-sent',
    TopicQuoteApproved: 'quote-approved',
    TopicQuoteDeclined: 'quote-declined',
    TopicLocaleChange: 'locale-change',
    TopicLandedOnPhone: 'landed-on-phone',
    TopicRefreshCustomerDetails: 'refresh-customer-details',
    TopicRefreshQuoteFormSilently: 'refresh-quote-form-silently',
    TopicPricingTableItemOptionsChanged: 'pricing-table-item-options-changed',
    TopicPricingTableOptionsSelectedChanged: 'pricing-table-options-selected-changed',
    TopicCustomFormFieldChanged: 'custom-form-field-changed',
    TopicProposalPreApproved: 'proposal-pre-approved',
    TopicProposalPreDeclined: 'proposal-pre-declined',
    TopicProposalRefresh: 'proposal-refresh',
    TopicProposalTotalUpdated: 'proposal-total-updated',
    TopicPreProposalTotalUpdated: 'pre-proposal-total-updated',
    TopicSyncPricingTables: 'pricing-table-sync-required',
    //TODO: TopicUploaderImagesLoaded is not the best way to fix the initial loading of images
    //  Dropzone component should offer a better option soon
    TopicUploaderImagesLoaded: 'uploader-images-loaded',
    TopicUploaderDocumentsLoaded: 'uploader-documents-loaded',
    TopicProposalSectionEditorOpen: 'proposal-section-editor-open',
    TopicProposalPreviewRefresh: 'proposal-preview-refresh',
    TopicSendSuccessNotification: 'send-success-notification',
    TopicOpenVideoCall: 'open-video-call',
    TopicPaymentTransactionCreated: 'payment-transaction-created',
    TopicSignaturePadChanged: 'signature-pad-changed',
    TopicDocumentCalendarEventsRefreshed: 'document-calendar-events-refreshed',
    TopicCreateExternalCheckoutPaymentTransaction: 'create-external-checkout-payment-transaction-requested',
    dispatch: (topic, data) => {
        AppContext.getEventBus().dispatch(topic, data)
    },
    listen: (topic, listenerName, callback) => {
        AppContext.getEventBus().listen(topic, listenerName, callback)
    },
    unsubscribe: (topic, listenerName) => {
        const eventBus = AppContext.getEventBus()
        if (eventBus) {
            AppContext.getEventBus().unsubscribe(topic, listenerName)
        }
    }
}


// WEBPACK FOOTER //
// ./src/common/EventBus.js